import { useTranslation } from 'react-i18next'
import type { InheritedParent } from './inheritedConfidentiality'

/** Copy naming the parents a record inherits confidentiality from; null when it inherits from none. */
export const useInheritedConfidentialityCopy = (inheritedFrom: readonly InheritedParent[]) => {
  const { t } = useTranslation('settings', { keyPrefix: 'record-access.inherited-confidentiality' })
  const shown = inheritedFrom.find((parent) => parent.name != null) ?? inheritedFrom.at(0)
  if (shown == null) return null

  const first = shown.name ?? t(`parent.${shown.type}`)
  const parents = inheritedFrom.length === 1 ? first : t('parents', { first, count: inheritedFrom.length - 1 })
  return {
    parents,
    chip: t('chip', { parents }),
    chipTooltip: t('chip-tooltip', { parents }),
    markKeepsConfidential: t('mark-keeps-confidential', { parents }),
    unmarkKeepsConfidential: t('unmark-keeps-confidential', { parents }),
  }
}
